import getGraphQlClient from '~graphql/getGraphQlClient';
import {
  CREATE_EDITOR_CANVAS,
  UPDATE_EDITOR_CANVAS,
  GET_EDITOR_CANVAS_BY_ID,
  GET_EDITOR_CANVAS_PAGES_PAGINATED,
} from '../queries/editorCanvas';
import {
  unmarshalGraphqlResponse,
  unmarshalGraphqlEdges,
} from '~graphql/utils';
import { trackEvent } from '~src/tracking/trackEvent';

const PAGES_BATCH_SIZE = 100;

export const createEditorCanvas = async (fields) => {
  const graphQlClient = await getGraphQlClient();

  const response = await graphQlClient.mutate({
    variables: { fields },
    mutation: CREATE_EDITOR_CANVAS,
  });

  const result = unmarshalGraphqlResponse(response.data, 'createEditor_canvas');

  // Via trackEvent, non trackGleapEvent: è il canale che applica le esclusioni
  // di editorConfig, altrimenti le org escluse sporcherebbero i dati Gleap.
  trackEvent('giotto_progetto_creato', {
    objectId: result.editor_canvas.objectId,
  });

  return result.editor_canvas;
};

export const updateEditorCanvas = async (id, fields) => {
  const graphQlClient = await getGraphQlClient();

  const response = await graphQlClient.mutate({
    variables: { id, fields },
    mutation: UPDATE_EDITOR_CANVAS,
  });

  const result = unmarshalGraphqlResponse(response.data, 'updateEditor_canvas');

  return result.editor_canvas;
};

export const fetchEditorCanvasById = async (
  id,
  batchSize = PAGES_BATCH_SIZE
) => {
  const graphQlClient = await getGraphQlClient();

  const response = await graphQlClient.query({
    variables: { id },
    query: GET_EDITOR_CANVAS_BY_ID,
  });
  // Read count and cursor before unmarshalling (unmarshal flattens nested connections)
  const initialConnection =
    response?.data?.getEditorCanvas?.editor_canvas_pages || {};
  const totalCount = initialConnection?.count || 0;
  const initialCursor = initialConnection?.pageInfo?.endCursor || null;

  const result = unmarshalGraphqlResponse(response.data, 'getEditorCanvas');

  // Ensure we have an array for pages
  const pagesArray = Array.isArray(result.editor_canvas_pages)
    ? result.editor_canvas_pages
    : [];

  // If more than the first page worth, fetch sequential batches
  if (typeof totalCount === 'number' && totalCount > pagesArray.length) {
    let fetched = pagesArray.length;
    let cursor = initialCursor;
    while (fetched < totalCount && cursor) {
      const limit = Math.min(batchSize, totalCount - fetched);
      const nextResp = await graphQlClient.query({
        variables: { id, limit, after: cursor },
        query: GET_EDITOR_CANVAS_PAGES_PAGINATED,
        fetchPolicy: 'network-only',
      });

      const conn = nextResp?.data?.getEditorCanvas?.editor_canvas_pages;
      if (!conn) break;
      const nodes = unmarshalGraphqlEdges(conn).edges || [];
      if (!nodes.length) break;
      pagesArray.push(...nodes);

      fetched += nodes.length;
      const pageInfo = conn.pageInfo || {};
      cursor = pageInfo.endCursor || null;
      if (pageInfo.hasNextPage === false) break;
    }
  }

  // Return the result with aggregated pages
  result.editor_canvas_pages = pagesArray;
  return result;
};
